<template>
  <el-dialog
    title="热区编辑"
    class="component__hot"
    @open="openHot"
    :visible.sync="hotData.visible"
    :close-on-click-modal="false"
    width="50%">
    <div class="hot__zone" :style="zoneStyle">
      <div class="hot__zone__item" v-for="(item,index) in hotList" :key="index"
           :style="item.style+`;line-height:${item.height}px`"
           @mousedown="dragsHot(arguments[0],item,index)">
        <div class="hot__zone__item__bg">热区{{index+1}}</div>
        <div class="hot__zone__item__right" @mousedown.stop="dragsHotChang(arguments[0],item,index,'right')"></div>
        <div class="hot__zone__item__bottom" @mousedown.stop="dragsHotChang(arguments[0],item,index,'bottom')"></div>
        <div class="hot__zone__item__bottom-right" @mousedown.stop="dragsHotChang(arguments[0],item,index,'all')"></div>
        <i @click.stop="hotDelete(index)" class="el-icon-circle-close hot__zone__item__delete"> </i>
      </div>
    </div>
    <img class="hot__bg" ref="hotImgRef" :src="hotData.imgUrl" alt="图片加载失败"/>
    <span slot="footer" class="dialog-footer">
      <el-button size="small " type="primary" @click="addHost">添加热区</el-button>
      <el-button size="small" @click="closeHot">保存</el-button>
    </span>
  </el-dialog>
</template>

<script type="text/babel">
  import $ from 'jquery'

  let scrollTop = 0;

  export default {
    name: 'hot',
    props: {
      hotData: {
        type: Object,
        default () {
          return {
            visible: false,
            list: [
              {
                top: 0,
                left: 0,
                height: 200,
                width: 200,
                href: null,
                medNumber: null
              }
            ],
            imgUrl: null,
            index: 0
          }
        }
      }
    },
    data () {
      return {
        zoneStyle: null,
        hotList: []
      }
    },
    created () {
    },
    methods: {
      closeHot () {
        const vm = this
        vm.$emit('close', vm.hotList)
        vm.hotList = []
      },
      openHot () {
        this.setStyle()
        this.init()
      },
      setStyle () {
        const vm = this
        vm.$nextTick(() => {
          const width = vm.$refs['hotImgRef'].naturalWidth
          const height = vm.$refs['hotImgRef'].naturalHeight
          vm.zoneStyle = `height:${height}px;width:${width}px`
        })
      },
      init () {
        const vm = this
        const list = []
        vm.hotData.list.forEach((ele) => {
          ele['style'] = vm.itemSetStyle(ele)
          ele.left = Number(ele.left)
          ele.top = Number(ele.top)
          ele.height = Number(ele.height)
          ele.width = Number(ele.width)
          list.push(ele)
        })
        vm.hotList = vm.$lodash.cloneDeep(list)
        $('.el-dialog__body').scroll((e) => {
          vm.hotScroll(e)
        })
      },
      /*
       *  拖拽
       * */
      dragsHot (event, item, index) {
        const vm = this;
        const left = item.left;
        const top = item.top;
        const width = vm.$refs['hotImgRef'].naturalWidth;
        const height = vm.$refs['hotImgRef'].naturalHeight;
        const hotZoneRight = width - item.width;
        const hotZoneBottom = height - item.height;
        document.onmousemove = (e) => {
          move(e)
        }

        function move (e) {
          const newLeft = left + (e.clientX - event.clientX);
          const newTop = top + (e.clientY - event.clientY);
          item.left = newLeft < 0 ? 0 : newLeft;
          item.top = newTop < 0 ? 0 : newTop;
          if (item.left > hotZoneRight) item.left = hotZoneRight;
          if (item.top > hotZoneBottom) item.top = hotZoneBottom;
          item.style = vm.itemSetStyle(item)
          vm.hotList.splice(index, 1, item)
        }

        document.onmouseup = (e) => {
          document.onmousemove = null
          document.onmouseup = null
        }
      },
      /*
       * 改变热区大小
       * */
      dragsHotChang (event, item, index, type = 'all') {
        let changeWidthType = false
        let changeHeightType = false
        if (type === 'all') {
          changeWidthType = true
          changeHeightType = true
        } else if (type === 'right') {
          changeWidthType = true
        } else if (type === 'bottom') {
          changeHeightType = true
        }
        const vm = this
        const zoneHeight = item.height
        const zoneWidth = item.width
        const parentWidth = vm.$refs['hotImgRef'].naturalWidth
        const parentHeight = vm.$refs['hotImgRef'].naturalHeight
        document.onmousemove = (e) => {
          change(e)
        }

        function change (e) {
          const newHeight = zoneHeight + (e.clientY - event.clientY);
          const newWidth = zoneWidth + (e.clientX - event.clientX);
          if (changeWidthType) {
            const maxWidth = parentWidth - item.left;
            item.width = newWidth < 1 ? 1 : newWidth;
            if (item.width > maxWidth) item.width = maxWidth
          }
          if (changeHeightType) {
            const maxHeight = parentHeight - item.top;
            item.height = newHeight < 1 ? 1 : newHeight;
            if (item.height > maxHeight) item.height = maxHeight
          }
          item.style = vm.itemSetStyle(item)
          vm.hotList.splice(index, 1, item)
        }

        document.onmouseup = (e) => {
          document.onmousemove = null
          document.onmouseup = null
        }
      },
      itemSetStyle (item) {
        return `top:${item.top}px;left:${item.left}px;height:${item.height}px;width:${item.width}px`
      },
      addHost () {
        const vm = this
        const item = {
          top: scrollTop,
          left: 0,
          height: 200,
          width: 200,
          style: null,
          href: null,
          medNumber: null
        }
        item.style = vm.itemSetStyle(item)
        this.hotList.push(item)
      },
      hotScroll (e) {
        scrollTop = e.target.scrollTop
      },
      hotDelete (index) {
        this.hotList.splice(index, 1)
      }
    }
  }
</script>

<style lang="scss">
  .component__hot {
    .el-dialog__body {
      overflow: auto;
      max-height: 500px;
      position: relative;
    }
    .hot__bg {
      border: 1px solid #0074D9;
    }
    .hot__zone {
      position: absolute;
    }
    .hot__zone__item {
      position: absolute;
      padding: 1px;
      text-align: center;
    }
    .hot__zone__item__bg {
      border: 1px solid #0074D9;
      background-color: rgba(0, 116, 217, 0.21);
      height: calc(100% - 2px);
      width: calc(100% - 2px);
    }

    .hot__zone__item__right {
      position: absolute;
      height: 100%;
      top: 0;
      right: 0;
      width: 20px;
    }
    .hot__zone__item__bottom {
      position: absolute;
      height: 20px;
      width: 100%;
      bottom: 0;
      left: 0;
    }
    .hot__zone__item__bottom-right {
      position: absolute;
      height: 20px;
      width: 20px;
      bottom: 0;
      right: 0;
      z-index: 1;
    }
    .hot__zone__item__right:hover {
      cursor: w-resize;
    }
    .hot__zone__item__bottom:hover {
      cursor: s-resize;
    }
    .hot__zone__item__bottom-right:hover {
      cursor: se-resize;
    }
    .hot__zone__item:hover {
      cursor: move
    }
    .hot__zone__item:hover .hot__zone__item__delete {
      cursor: pointer;
      z-index: 10;
    }
    .hot__zone__item__delete {
      font-size: 16px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: -10;
    }

  }
</style>
